var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessReapply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#75C907"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14370_6219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.5H18.5V7.5",
    stroke: "#75C907",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7747 16.0002C14.9884 16.7421 14.001 17.2359 12.9358 17.4198C11.8705 17.6037 10.7747 17.4697 9.78523 17.0344C8.79574 16.5991 7.95648 15.8818 7.37229 14.9723C6.78811 14.0627 6.48491 13.0012 6.50058 11.9203C6.51625 10.8394 6.85009 9.78708 7.4604 8.89484C8.07071 8.0026 8.93041 7.30999 9.93209 6.90356C10.9338 6.49712 12.033 6.39487 13.0925 6.6096C14.152 6.82432 15.1246 7.34649 15.889 8.11087L18.4997 10.5002",
    stroke: "#75C907",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14370_6219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessReapply);
export default __webpack_public_path__ + "static/media/AccessReapply.dabd2b70e418eef35ce76ad12c22b0c6.svg";
export { ForwardRef as ReactComponent };